<div class="mt-50">
  <div class="help-center">
    <div class="row is-flex">
      <ng-container *ngIf="loading$ | async; else return">
        <ecp-loader *ngIf="loading$ | async" [fluid]="true"></ecp-loader>
      </ng-container>
      <ng-template #return>
        <div class="col is-flex is-fullwidth">
          <div class="container" *ngIf="myreturns$ | async; else noBrands">
            <mat-tab-group (selectedTabChange)="onTabChanged($event)">
              <mat-tab *ngFor="let ra of refreshNames" label="{{ ra }}">
                <div class="col is-flex is-fullwidth">
                  <ecp-return-search></ecp-return-search>
                </div>
                <div class="col is-flex is-fullwidth">
                  <ecp-print-my-return></ecp-print-my-return>
                </div>
                <div class="col is-flex is-fullwidth">
                  <ecp-return-list-table></ecp-return-list-table>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </ng-template>
      <ng-template #noBrands>
        <div class="row">
          <div class="col s12">
            <mat-card class="mat-card--widget">
              <mat-card-content class="offers-list__empty">
                <div class="container text-center">
                  <h3 class="h3">
                    Your Refresh returns cart is empty. Please check back during the next Refresh for the list of frames
                    to be returned.
                  </h3>
                  <p>
                    Please refer to the Refresh document in the Resource section of the Help Center for Refresh
                    instructions.
                  </p>
                  <a routerLink="/" class="btn btn-link">Return to my catalog</a>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
